import React from "react";

export interface TabsProps {
  tabs: {
    title: string;
    onClick: () => void;
  }[];
  activeTab: string;
}

const Tabs = ({ tabs, activeTab }: TabsProps) => {
  return (
    <ul className="flex">
      {tabs.map((item, key) => (
        <li key={key}>
          <button
            type="button"
            className={`inline-block px-3 py-1 transition-colors duration-300 border border-aqua ${
              item.title === activeTab
                ? "bg-aqua text-white hover:bg-darkAqua"
                : "bg-transparent text-aqua hover:bg-gray-200"
            } ${
              tabs.length === 1
                ? "rounded"
                : key === 0
                ? "rounded-l"
                : key === tabs.length - 1
                ? "rounded-r"
                : ""
            }`}
            onClick={item.onClick}
          >
            {item.title}
          </button>
        </li>
      ))}
    </ul>
  );
};

export default Tabs;
